export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/wavAnalyzer.worker.789c10ab.worker.js");
}
